import { Service, BaseService } from "@/core/auto";

@Service('/api/usr/inquire')
export default class UsrInquire extends BaseService {
	index() {
		return this.request({
			url: "/index",
			method: "POST"
		});
	}
    create(formData, files) {
		const data = formData.model
        var form = new FormData();
		for (const key in data) {
			if (data.hasOwnProperty(key)) {
				if (data[key] !== null && data[key] !== undefined){
					if(key == 'submitBeginTm' && data[key]) {
						form.append(key,data[key]);
					} else if (key != 'submitBeginTm') {
						form.append(key,data[key]);
					}
				}
			}
		}
		if (files) {
			for (var i = 0; i < files.length; i++) {
				form.append("upload1", files[i]);
			}
		} else {
			form.append("upload1", null);
		}
		return this.request({
            data: form,
			url: "/create",
			method: "POST"
		});
	}
	send() {
		return this.request({
			url: "/send",
			method: "POST",
		});
	}
}